import FastUpload from './index.vue';
import {withInstall} from "@/utils/tool";

export default withInstall(FastUpload)
